module.exports = __webpack_public_path__ + "static/media/closedLoansBorrower.e57220c4.svg";